"use client";

import { c as _c } from "react/compiler-runtime";
import { Icon, IconButton, Tooltip, Typography } from "@/shared/ui/atoms";
import { useState } from "react";
interface SubjectTitleProps {
  title: string;
  tooltip?: boolean;
  tooltipContent: string;
}
const SubjectTitle = t0 => {
  const $ = _c(10);
  const {
    title,
    tooltip: t1,
    tooltipContent
  } = t0;
  const tooltip = t1 === undefined ? false : t1;
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Icon src="/icons/ai-icon.svg" alt="subject" width={24} height={24} />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== title) {
    t3 = <Typography size={16} className="text-gray-800 font-semibold">{title}</Typography>;
    $[1] = title;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== isTooltipOpen || $[4] !== tooltip || $[5] !== tooltipContent) {
    t4 = tooltip && <div className="relative inline-flex shrink-0 items-center justify-center"><IconButton onClick={() => setIsTooltipOpen(!isTooltipOpen)} className="overflow-visible" width={15} height={15}><Icon src="/icons/tooltip.png" alt="subject" width={15} height={15} /></IconButton>{isTooltipOpen && <Tooltip content={tooltipContent} />}</div>;
    $[3] = isTooltipOpen;
    $[4] = tooltip;
    $[5] = tooltipContent;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <div className="relative flex items-center gap-[6px] py-2 px-4">{t2}{t3}{t4}</div>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};
export default SubjectTitle;